import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/services/app-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-exam-header',
  templateUrl: './exam-header.component.html',
  styleUrls: ['./exam-header.component.scss']
})
export class ExamHeaderComponent implements OnInit {

  @Input('pageTitle') pageTitle;
  @Input('imageClass') imageClass;
  siteUrl = environment.siteUrl;
  isMobileMenu = false;
  imageUrl = '';
  showLoginPopup = false;
  popupMessage = '';
  
  constructor(public router: Router, private appService: AppService, private toastr: ToastrService) { }

  ngOnInit() {
    let bannerObj = this.appService.getPageByKey('banner');
    let bannerObj2 = this.appService.getPageByKey('innerPageBanner');


    if (this.imageClass == 'home') {
      this.imageUrl = bannerObj.title;
    } else {
      this.imageUrl = bannerObj2.title;
    }

    if (!this.imageUrl.indexOf('assets')) {
      this.imageUrl = this.siteUrl + '/api/static' + this.imageUrl;
    }
  }

  openMobileMenu() {
    this.isMobileMenu = true;
  }

  closeMobileMenu() {
    this.isMobileMenu = false;
  }

  isCheckLogin() {
    return sessionStorage.getItem('loginId')
  }

  logout() {
    sessionStorage.removeItem('loginId');
    sessionStorage.removeItem('access_token');
    this.router.navigate(['login']);
  }

  redirectToLogin(intendedRoute: string) {
    // Store the intended route to redirect after login
    // sessionStorage.setItem('redirectAfterLogin', intendedRoute);
    // // Show popup message instead of alert
    // this.popupMessage = 'Please login to access the library';
    // this.showLoginPopup = true;
    // // We'll navigate to login when user clicks the button in the popup
    this.toastr.info('Please login to access the library');
    this.router.navigate(['login']);
  }
  
  closePopup() {
    this.showLoginPopup = false;
  }
  
  goToLogin() {
    this.showLoginPopup = false;
    this.router.navigate(['login']);
  }

}
